import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSpinner,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import type { MediaId } from 'models/Media';
import { useMediaUrl } from 'hooks/useMediaUrl';

interface Props {
  mediaId: MediaId;
  className?: string;
}

// A <video controls> for a stored media file.
export const MediaVideo: FC<Props> = ({ mediaId, className }) => {
  const { url, status, onError } = useMediaUrl(mediaId);

  if (status === 'ready' && url) {
    return (
      <video
        controls
        preload="metadata"
        src={url}
        className={className}
        onError={onError}
      />
    );
  }

  // Icon-only placeholder, matching MediaImage (no untranslated text).
  return (
    <div className={styles.placeholder}>
      <FontAwesomeIcon
        icon={status === 'error' ? faTriangleExclamation : faSpinner}
        className={status === 'error' ? undefined : 'animate-spin'}
        aria-hidden="true"
      />
    </div>
  );
};

const styles = {
  placeholder:
    'flex aspect-video items-center justify-center rounded-xl bg-gray-100 text-gray-400',
};
